import axios from 'axios'
import { CADASTRAR_CONFIGURACAO_EXCESSO_BAGAGEM } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarConfiguracaoExcessoBagagem(empresaId, configuracao) {
  const url = `${URL}/empresas/${empresaId}/cadastrar-configuracao-excesso-bagagem`;
  return dispatch => axios.post(url, configuracao, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: CADASTRAR_CONFIGURACAO_EXCESSO_BAGAGEM,
      payload: response
    })
  );
}
